import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAntigravity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 55,
	viewBox: "0 0 56 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_117157_1875)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_117157_1875",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 2,
				width: 54,
				height: 50,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M48.9403 50.7419C51.9555 53.0034 56.4776 51.4956 52.332 47.3503C39.8957 35.2908 42.534 2.12732 27.0827 2.12732C11.6315 2.12732 14.2695 35.2908 1.83311 47.3503C-2.68918 51.8725 2.20995 53.0034 5.22485 50.7419C16.9075 42.8281 16.1538 28.8843 27.0827 28.8843C38.0114 28.8843 37.2578 42.8281 48.9403 50.7419Z",
					fill: "black"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_117157_1875)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter0_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M-2.29143 -9.10398C-3.20842 -1.02536 3.7533 6.39821 13.258 7.47706C22.7627 8.5559 31.2111 2.88144 32.1281 -5.19719C33.0451 -13.2758 26.0834 -20.6994 16.5787 -21.7782C7.074 -22.857 -1.37444 -17.1826 -2.29143 -9.10398Z",
							fill: "#FFE432"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter1_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M34.355 17.307C36.7363 27.5599 47.1611 33.8986 57.6394 31.4649C68.1178 29.0312 74.6817 18.7467 72.3003 8.49379C69.9189 -1.75915 59.4941 -8.09786 49.0158 -5.66417C38.5374 -3.23049 31.9736 7.05405 34.355 17.307Z",
							fill: "#FC413D"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter2_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M-27.9955 24.1854C-24.9864 34.7667 -11.4349 40.1847 2.27285 36.2865C15.9806 32.3884 24.6535 20.6505 21.6445 10.0692C18.6355 -0.512132 5.08386 -5.92996 -8.62383 -2.03185C-22.3315 1.86623 -31.0045 13.6041 -27.9955 24.1854Z",
							fill: "#00B95C"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter3_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M-27.9955 24.1854C-24.9864 34.7667 -11.4349 40.1847 2.27285 36.2865C15.9806 32.3884 24.6535 20.6505 21.6445 10.0692C18.6355 -0.512132 5.08386 -5.92996 -8.62383 -2.03185C-22.3315 1.86623 -31.0045 13.6041 -27.9955 24.1854Z",
							fill: "#00B95C"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter4_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M-17.1181 32.9546C-9.57487 40.6592 3.41626 40.1729 11.8984 31.8686C20.3805 23.5642 21.1416 10.5863 13.5984 2.88161C6.05516 -4.82303 -6.93597 -4.33682 -15.4181 3.96761C-23.9002 12.272 -24.6613 25.25 -17.1181 32.9546Z",
							fill: "#00B95C"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter5_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M22.3468 62.0131C24.6891 72.0983 34.4608 78.4452 44.1723 76.1897C53.8837 73.9339 59.8577 63.93 57.5152 53.8449C55.1731 43.7597 45.4016 37.4128 35.6898 39.6683C25.9783 41.9242 20.0044 51.928 22.3468 62.0131Z",
							fill: "#3186FF"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter6_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M5.78781 -18.5418C0.883011 -7.61589 6.24921 5.4352 17.7735 10.6086C29.2978 15.7819 42.6163 11.1185 47.5209 0.192586C52.4258 -10.7334 47.0595 -23.7845 35.5355 -28.9578C24.011 -34.1313 10.6926 -29.4678 5.78781 -18.5418Z",
							fill: "#FBBC04"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter7_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M-7.3501 86.9189C-19.2241 82.2581 1.06828 43.9063 6.11424 31.0527C11.1603 18.1991 24.8767 11.558 36.7506 16.2194C48.6248 20.8808 62.6992 46.555 57.6527 59.4088C52.6067 72.2622 4.52394 91.5801 -7.3501 86.9189Z",
							fill: "#3186FF"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter8_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M64.5974 39.1855C61.4182 42.8955 53.1223 41.0037 46.0679 34.9594C39.0135 28.9152 35.8719 21.0077 39.0507 17.2974C42.2296 13.5872 50.5254 15.4792 57.5798 21.5233C64.6342 27.5675 67.7762 35.475 64.5974 39.1855Z",
							fill: "#749BFF"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter9_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M40.8665 20.2984C53.9414 29.1428 68.9975 29.7238 74.4955 21.5961C79.9935 13.4685 73.8514 -0.290083 60.7764 -9.13448C47.7015 -17.9789 32.6455 -18.5599 27.1476 -10.4322C21.6496 -2.30455 27.7919 11.454 40.8665 20.2984Z",
							fill: "#FC413D"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						filter: "url(#filter10_f_117157_1875)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M-2.05908 5.9124C-5.29826 13.7263 -4.24035 21.5878 0.303837 23.4715C4.84802 25.3553 11.1577 20.548 14.3969 12.7341C17.636 4.92015 16.5781 -2.94134 12.0339 -4.82509C7.48977 -6.70884 1.1801 -1.9015 -2.05908 5.9124Z",
							fill: "#FFEE48"
						})
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_117157_1875",
				x: -7.39921,
				y: -26.9364,
				width: 44.6351,
				height: 39.5717,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.51333,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_f_117157_1875",
				x: 9.56569,
				y: -30.4856,
				width: 87.5239,
				height: 86.7719,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 12.1506,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_f_117157_1875",
				x: -49.2502,
				y: -23.9545,
				width: 92.1492,
				height: 82.1636,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 10.3292,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_f_117157_1875",
				x: -49.2502,
				y: -23.9545,
				width: 92.1492,
				height: 82.1636,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 10.3292,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_f_117157_1875",
				x: -42.9713,
				y: -23.2516,
				width: 82.4229,
				height: 82.3394,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 10.3292,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_f_117157_1875",
				x: 2.20683,
				y: 19.5816,
				width: 75.4484,
				height: 76.6949,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 9.81578,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter6_f_117157_1875",
				x: -13.821,
				y: -48.8604,
				width: 80.9509,
				height: 79.3715,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 8.89587,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter7_f_117157_1875",
				x: -26.91,
				y: -1.15925,
				width: 101.506,
				height: 104.677,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 7.94437,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter8_f_117157_1875",
				x: 23.5927,
				y: 1.18058,
				width: 56.4626,
				height: 54.1216,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 7.10881,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter9_f_117157_1875",
				x: 13.1246,
				y: -28.1758,
				width: 75.3939,
				height: 67.5156,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 6.00424,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter10_f_117157_1875",
				x: -18.7988,
				y: -20.0963,
				width: 49.9354,
				height: 58.839,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 7.43125,
						result: "effect1_foregroundBlur_117157_1875"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_117157_1875",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 55.6231,
					height: 52.1467,
					fill: "white",
					transform: "translate(0 2.12732)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAntigravity);
export { ForwardRef as ReactComponent };
